var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('LazyImg',{attrs:{"autoLoad":_vm.autoLoad,"preload":_vm.url.preSrc,"src":_vm.url.src},on:{"loaded":_vm.onLoaded},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var bestImg = ref.bestImg;
var loaded = ref.loaded;
return [_c('div',{staticClass:"img",class:{ loading: !loaded, blur: !loaded && _vm.blur },style:({ backgroundImage: ("url(" + bestImg + ")") })},[_vm._t("default")],2)]}}],null,true)})}
var staticRenderFns = []

export { render, staticRenderFns }